import React, {useState,useContext} from 'react'
import axios from 'axios'
import signup from "../images/signup.svg"
import { NavLink, useNavigate } from 'react-router-dom'


function Register() {

  const navigate = useNavigate();
  const [user, setUser] = useState({
    name:"",email:"",phone:"",work:"",password:"",cpassword:""
  });

  let name,value;
  const handleInputs = (e) =>{
    name = e.target.name;
    value = e.target.value;

    setUser(values => ({...values, [name]: value}))

}

const postData = async (e)=>{
  e.preventDefault();

  const {name,email,phone,work,password,cpassword} = user;
  axios.post("/register",user)
  .then(()=>{
    console.log("Data Added Succesfully");
    window.alert("Data Added Succesfully");
    navigate("/signin")})
  .catch((e)=>{console.log("Data Not Added Error"+e)})
}
  // const data = await res.json();

  // if(data === 422 || !data){
  //   window.alert("Invalid Registration");
  //   console.log("Invalid Registration");
  // } else{
  //   window.alert("Registration Successfull");
  //   console.log("Registration Successfull");
  //   navigate("/signin");
  // }


  return (
    <>

      <section style={{minHeight: "100vh"}} className='register bg-light border-top p-5'>
        <div className='bg-white border mx-auto w-auto rounded p-5'>
          <div className='signup-content '>
            <div className='signup-form'>
              <h2 className='text-center'>Register Yourself</h2>
              <div className='row pt-2'>
                  <div className='col-lg-6 pt-5'>
                  <form method='POST'>
  <div class="form-group row">
    <div class="col-sm-12">
      <input type="text" class="form-control" id="name" name="name"  autoComplete='off'
        value={user.name}
        onChange={handleInputs}
        placeholder='Full Name'
      />
    </div>
    </div>
  <div class="form-group row">
    <div class="col-sm-12">
      <input type="email" class="form-control" id="email" name="email" x autoComplete='off'
        value={user.email}
        onChange={handleInputs}
        placeholder='Email Address'
      />
    </div>
    </div>
  <div class="form-group row">
    <div class="col-sm-12">
      <input type="number" class="form-control" id="phone" name="phone"  autoComplete='off'
        value={user.phone}
        onChange={handleInputs}
        placeholder='Phone Number'
      />
    </div>
    </div>
  <div class="form-group row">
    <div class="col-sm-12">
      <input type="text" class="form-control" id="work" name="work"  autoComplete='off'
        value={user.work}
        onChange={handleInputs}
        placeholder='Your Profession'
      />
    </div>
    </div>
  <div class="form-group row">
    <div class="col-sm-12">
      <input type="password" class="form-control" id="password" name="password"  autoComplete='off'
        value={user.password}
        onChange={handleInputs}
        placeholder='Password'
      />
    </div>
  </div>
  <div class="form-group row">
    <div class="col-sm-12">
      <input type="password" class="form-control" id="cpassword" name="cpassword"  autoComplete='off'
        value={user.cpassword}
        onChange={handleInputs}
        placeholder='Confirm Password'
      />
    </div>
  </div>
  <div class="form-group row">
    <div class="col-sm-12 btn-group btn-group-justified">
      <button type="submit" class="btn btn-justified btn-dark" onClick={postData}>Register</button>
    </div>
  </div>
</form>
                  </div>
                  <div className='col-lg-6 '>
                    <img src={signup} alt='signup'/>
                    <NavLink to='/signin'>Already Have An Account??? Sign In</NavLink>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Register